import { OTHER_LOCATION } from '@/utils/constants';
import { IS_DEV } from '@/utils/env';

const INITIAL_STATE = {
  user: {
    isAuthenticated: false,
    isPosAdyen: false,
    isSalesRep: false,
    isGlobalEFF: null, // change to null
    notInternal: true,
    hasShowroomHeader: false,
    userName: '',
    userEmail: '',
    isEuropeanUnionMember: false,
    currCountry: '',
    currSymbol: '$',
    ipCountry: '',
    ipLatitude: null,
    ipLongitude: null,
    customerCity: 'other',
    customerIp: '',
    convenientShowroomPhoneNumber: '',
    convenientShowroomFullPhoneNumber: '',
    currShowroom: 'other',
    globalEFlag: null,
    globalESite: null,
    globalEUKOrAUFlag: null,
    thirdAuthButtonLocation: '',
  },
  showroom: {
    store: OTHER_LOCATION,
    visitText: 'Virtual Appointment',
    telCode: '1.',
    country: '',
  },
  wishlist: {
    items: [],
    currency: '',
  },
  cart: {
    items: [],
    gift_note: [],
    gift_promotion: [],
    subtotal: 0,
    totalItems: 0,
    currency: '',
  },
  appointment: {
    activePage: 1,
    isSetsterError: false,
    successfullBooking: false,
    locationsLoading: true,
    prevSelectedShowroomStore: {
      modalName: '',
      displayName1: '',
      displayName2: '',
      addresLine1: '',
      addressLine2: '',
      id: '',
      city: '',
      state: '',
      zipCode: '',
    },
    selectedShowroomStore: {
      modalName: '',
      displayName1: '',
      displayName2: '',
      addresLine1: '',
      addressLine2: '',
      id: '',
      city: '',
      state: '',
      zipCode: '',
      timezoneName: '',
      timezoneId: '',
      timezoneAbreviation: '',
    },
    selectedCity: '',
    selectedServiceName: '',
    selectedServiceId: '',
    selectedServiceDateNightId: '',
    selectedDate: null,
    selectedTime: '',
    selectedTimezone: '',
    selectedTimezoneName: '',
    selectedTimeId: '',
    selectedTimezoneId: '0', // PT
    setsterAvailabilityDateTimes: {},
    setsterAvailabilityDateNightTimes: {},
    isSelectedDateNightTime: false,
    setsterAvailabilityDateTimesLoading: true,
    companyId: IS_DEV ? '17597' : '11735',
    currentTimezone: '' as '' | 'PT' | 'ET' | 'CT' | 'MT' | 'AKT' | 'CT' | 'ET' | 'GT' | 'HT',
    contactInfo: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      optInUpdates: false,
      optInAppointmentAlerts: false,
    },
    firstAvailableDate: undefined,
  },
  glLocation: {
    localGeToggle: null,
    insertGeCode: null,
  },
};

export default INITIAL_STATE;
